import { LIMIT_SUGGESTIONS_SEARCH } from '@shopDetails/pages/MenuSearch/constants';
import getSuggestions, { storage } from './getSuggestions';

function createObjectSuggestion(
  value,
  shopId,
  userSuggestions,
  shopSuggestions,
) {
  return {
    ...userSuggestions,
    [shopId]: [
      ...shopSuggestions,
      {
        name: value.name,
        date: value.date,
      },
    ],
  };
}

async function addSuggestions(userId, shopId, value) {
  const userSuggestions = (await getSuggestions(userId)) || {};
  const shopSuggestions = userSuggestions?.[shopId] || [];
  let data = {};

  if (Object.keys(userSuggestions).length < LIMIT_SUGGESTIONS_SEARCH) {
    if (shopSuggestions?.length < LIMIT_SUGGESTIONS_SEARCH) {
      const exists = shopSuggestions.find(
        s => s.name.toLowerCase() === value.name.toLowerCase(),
      );

      if (exists) {
        const newSuggestion = {
          name: value.name,
          date: value.date,
        };

        const index = shopSuggestions.findIndex(
          item => item.name === value?.name,
        );
        shopSuggestions.splice(index, 1, newSuggestion);

        data = {
          [shopId]: shopSuggestions,
        };
      } else {
        data = createObjectSuggestion(
          value,
          shopId,
          userSuggestions,
          shopSuggestions,
        );
      }
    } else {
      shopSuggestions.pop();
      data = createObjectSuggestion(
        value,
        shopId,
        userSuggestions,
        shopSuggestions,
      );
    }
  } else {
    const suggestionObject = Object.keys(userSuggestions);
    delete userSuggestions[suggestionObject[suggestionObject.length - 1]];
    data = createObjectSuggestion(
      value,
      shopId,
      userSuggestions,
      shopSuggestions,
    );
  }
  return storage.set(userId, data);
}

export default addSuggestions;
